import { useEffect, useRef, useState } from "react";

const stats = [
  { label: "Projetos entregues", value: 50, prefix: "+" },
  { label: "Clientes satisfeitos", value: 20, prefix: "+" },
  { label: "Anos de experiência", value: 12, prefix: "+" },
];

function Stats() {
  const [counts, setCounts] = useState(stats.map(() => 0));
  const [hasStarted, setHasStarted] = useState(false);

  const statsRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !hasStarted) {
          startCounting();
          setHasStarted(true);
        }
      },
      { threshold: 0.3 }
    );

    if (statsRef.current) {
      observer.observe(statsRef.current);
    }

    return () => observer.disconnect();
  }, [hasStarted]);

  function startCounting() {
    const duration = 1500; // ms
    const start = performance.now();

    function animate(now) {
      const progress = Math.min((now - start) / duration, 1);

      setCounts(
        stats.map((stat) => Math.floor(stat.value * progress))
      );

      if (progress < 1) {
        requestAnimationFrame(animate);
      }
    }

    requestAnimationFrame(animate);
  }

  return (
    <section id="resultados" className="section" ref={statsRef}>
      <h2>Resultados em números</h2>
      <div className="stats">
        {stats.map((stat, i) => (
          <div className="stat" key={stat.label}>
            <h3>
              {stat.prefix}
              {counts[i]}
            </h3>
            <p>{stat.label}</p>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Stats;
